import React from 'react';
import ContentLoader from 'react-content-loader';

const ProgramLoader = () => (
  <ContentLoader 
    speed={2}
    width={400}
    height={160}
    viewBox="0 0 400 160"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
  >
    <circle cx="59" cy="68" r="41" /> 
    <rect x="0" y="7" rx="0" ry="0" width="417" height="10" /> 
    <rect x="124" y="36" rx="0" ry="0" width="307" height="9" /> 
    <rect x="124" y="56" rx="0" ry="0" width="307" height="9" /> 
    <rect x="124" y="75" rx="0" ry="0" width="307" height="9" /> 
    <rect x="124" y="93" rx="0" ry="0" width="307" height="9" /> 
    <rect x="0" y="117" rx="0" ry="0" width="417" height="10" /> 
    <rect x="-1" y="136" rx="0" ry="0" width="417" height="10" />
  </ContentLoader>
);

export default ProgramLoader;
